import CardCourse from '~/components/Molecules/CardCourse/CardCourse.vue'
import CardSignup from '~/components/Molecules/CardSignup/CardSignup.vue'
import CardWhyHotmart from '~/components/Molecules/CardWhyHotmart/CardWhyHotmart.vue'
import CardTestimonial from '~/components/Molecules/CardTestimonial/CardTestimonial.vue'
import CardProducer from '~/components/Molecules/CardProducer/CardProducer.vue'

export default {
  props: {
    propBus: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      cardCourse: CardCourse,
      cardSignup: CardSignup,
      cardWhyHotmart: CardWhyHotmart,
      cardTestimonial: CardTestimonial,
      cardProducer: CardProducer,

      swiperCreateSell: {
        slidesPerView: 1,
        spaceBetween: 16,
        allowTouchMove: true,
        resistanceRatio: 0,
        slideToClickedSlide: true,
        breakpoints: {
          480: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: 3,
            allowTouchMove: false,
          },
          1440: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          el: '.swiper-navigation',
          clickable: true,
        },
      },

      swiperTestimonials: {
        slidesPerView: 1,
        spaceBetween: 16,
        allowTouchMove: true,
        resistanceRatio: 0,
        slideToClickedSlide: true,
        breakpoints: {
          480: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            spaceBetween: 60,
            slidesPerView: 3,
            allowTouchMove: false,
          },
          1440: {
            slidesPerView: 3,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          el: '.swiper-navigation',
          clickable: true,
        },
      },

      swiperTeachers: {
        slidesPerView: 1.1,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
        spaceBetween: 24,
        allowTouchMove: true,
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            slidesPerColumn: 1,
          },
          768: {
            slidesPerView: 2.1,
            slidesPerColumn: 1,
          },
          1024: {
            slidesPerView: 3,
            slidesPerColumn: 3,
            allowTouchMove: false,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },

      swiperWhyChoose: {
        slidesPerView: 1,
        spaceBetween: 16,
        allowTouchMove: true,
        resistanceRatio: 0,
        slideToClickedSlide: true,
        breakpoints: {
          480: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: 3,
            allowTouchMove: false,
          },
          1440: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          el: '.swiper-navigation',
          clickable: true,
        },
      },
    }
  },
}
